import React from "react";
import Icon from "@ant-design/icons";

const StudentSelectSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M10.0282 14.4479L9.12234 11.0671M9.12234 11.0671L7.4494 12.5507L7.82834 6.23749L11.3131 11.5154L9.12234 11.0671ZM8 1.5V3M11.8891 3.11091L10.8284 4.17157M13.5 7H12M5.17157 9.82843L4.11091 10.8891M4 7H2.5M5.17157 4.17157L4.11091 3.11091"
			stroke="#344054"
			// stroke-linecap="round"
			// stroke-linejoin="round"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const StudentSelectIcon = (props) => (
	<Icon component={() => <StudentSelectSvg {...props} />} />
);

export default StudentSelectIcon;
